import React from 'react';
import {t} from 'i18next';
import {BreadcrumbsDTO} from '../../models/dto/BreadcrumbsDTO';
import {BreadcrumbContainer, BreadcrumbElement} from './Breadcrumb.style';
import {generateIdentifier} from '../../utils/IdentityUtils';

export interface BreadcrumbProps {
    readonly breadcrumbs: BreadcrumbsDTO[];
    readonly breadcrumbPath: BreadcrumbPaths;
    onPathClicked: (path: string) => void;
}

export enum BreadcrumbPaths {
    HOME = 'HOME',
    FILTERED = 'FILTERED',
    RECENTLY_ADDED = 'RECENTLY_ADDED',
    FAVORITES = 'FAVORITES',
    PUBLIC_ACCESS = 'PUBLIC_ACCESS'
}

export const Breadcrumb: React.VFC<BreadcrumbProps> = (props) => {
    const handlePathClicked = (path: BreadcrumbsDTO) => {
        let clickedPathIndex = props.breadcrumbs.indexOf(path);
        let newPath = props.breadcrumbs.slice(0, clickedPathIndex + 1).map(obj => obj.storagePathPart);
        props.onPathClicked('/' + newPath.join('/'));
    };

    const handleRootClicked = () => {
        props.onPathClicked('/');
    };

    const getBreadcrumbPathElement = () => {
        switch (props.breadcrumbPath) {
            case BreadcrumbPaths.HOME:
                return (
                    <BreadcrumbElement id={generateIdentifier()}
                                       key={'home'}
                                       onClick={() => handleRootClicked()}>
                        {t('BREADCRUMB_PATH_HOME')}
                    </BreadcrumbElement>
                );
            case BreadcrumbPaths.FILTERED:
                return (
                    <BreadcrumbElement id={generateIdentifier()}
                                       key={'home'}
                                       onClick={() => handleRootClicked()}>
                        {t('BREADCRUMB_PATH_FILTERED')}
                    </BreadcrumbElement>
                );
            case BreadcrumbPaths.RECENTLY_ADDED:
                return (
                    <BreadcrumbElement id={generateIdentifier()}
                                       key={'home'}
                                       onClick={() => handleRootClicked()}>
                        {t('BREADCRUMB_PATH_RECENTLY_ADDED')}
                    </BreadcrumbElement>
                );
            case BreadcrumbPaths.FAVORITES:
                return (
                    <BreadcrumbElement id={generateIdentifier()}
                                       key={'home'}
                                       onClick={() => handleRootClicked()}>
                        {t('BREADCRUMB_PATH_FAVORITES')}
                    </BreadcrumbElement>
                );
            case BreadcrumbPaths.PUBLIC_ACCESS:
                return (
                    <BreadcrumbElement id={generateIdentifier()}
                                       key={'home'}
                                       onClick={() => handleRootClicked()}>
                        {t('PUBLIC_ACCESS')}
                    </BreadcrumbElement>
                );
            default:
                return (
                    <BreadcrumbElement id={generateIdentifier()}
                                       key={'home'}
                                       onClick={() => handleRootClicked()}>
                        {t('BREADCRUMB_PATH_HOME')}
                    </BreadcrumbElement>
                );
        }
    };

    return (
        <BreadcrumbContainer id={generateIdentifier()}>
            {t('BREADCRUMB_PATH')}
            {getBreadcrumbPathElement()}
            {props.breadcrumbs.map(path => (
                <span id={generateIdentifier()}
                      key={decodeURI(path.labelPathPart)}>
                    {'/'}
                    <BreadcrumbElement id={generateIdentifier()}
                                       key={decodeURI(path.labelPathPart)}
                                       onClick={() => handlePathClicked(path)}>
                        {decodeURI(path.labelPathPart)}
                    </BreadcrumbElement>
                </span>
            ))}
        </BreadcrumbContainer>
    );
};
